const setRefundRecipientFormField = (state, action) =>
  Object.assign({}, state, { [action.name]: action.value })

export default setRefundRecipientFormField
